import axios from '../../../build/http-requests/axios-common'
import store from '../../store'
import FiltroPeriodoEnum from '../../enum/filtroPeriodo'

export default {
  state: {
    // Globais
    availableGadgets: [],
    currentRequests: {},
    periodDashboard: {
      id: FiltroPeriodoEnum.ULTIMOS_TRINTA_DIAS
    },
    plansDashboard: [],
    mainCategoriesDashboard: [],
    // Filtros do gráfico Distribuição de conciliação
    periodFilterConcSitSummary: {},
    planSelectedFilterConcSitSummary: {},
    typeFilterConcSituationSummary: {},
    mainCategorySelectedFilterConcSitSummary: {},
    // Filtros do gráfico Lançamentos conciliados
    periodFilterAllotmentDistribution: {},
    planSelectedFilterBatch: {},
    typeSelectedFilterBatch: {},
    mainCategorySelectedFilterBatch: {},
    // Filtros do gráfico Resumo financeiro
    periodFilterFinancialSummary: {},
    mainCategorySelectedFilterFinancialSummary: {},
    // Filtros do gráfico Saldo bancário
    periodFilterBankBalance: {},
    accountSelectedBankBalance: {},
    // Filtros do gráfico Saldo carteira digital
    periodFilterDigitalWalletBalance: {},
    categorySelectedDigitalWalletBalance: {}
  },

  mutations: {
    // Globais
    SET_AVAILABLE_GADGETS (state, gadgets) {
      state.availableGadgets = []
      state.availableGadgets = gadgets
    },
    CLEAN_GADGETS_FILTERS (state) {
      state.periodDashboard = {
        id: FiltroPeriodoEnum.ULTIMOS_TRINTA_DIAS
      }
      // Filtros do gráfico Distribuição de conciliação
      state.periodFilterConcSitSummary = {}
      state.planSelectedFilterConcSitSummary = {}
      state.typeFilterConcSituationSummary = {}
      state.mainCategorySelectedFilterConcSitSummary = {}
      // Filtros do gráfico Lançamentos conciliados
      state.periodFilterAllotmentDistribution = {}
      state.planSelectedFilterBatch = {}
      state.typeSelectedFilterBatch = {}
      state.mainCategorySelectedFilterBatch = {}
      // Filtros do gráfico Resumo financeiro
      state.periodFilterFinancialSummary = {}
      state.mainCategorySelectedFilterFinancialSummary = {}
      // Filtros do gráfico Saldo bancário
      state.periodFilterBankBalance = {}
      state.accountSelectedBankBalance = {}
      // Filtros do gráfico Saldo carteira digital
      state.periodFilterDigitalWalletBalance = {}
      state.categorySelectedDigitalWalletBalance = {}
    },
    SET_PERIOD_DASHBOARD (state, period) {
      state.periodDashboard = {...period}
    },
    SET_PLANS_FILTER_DASHBOARD (state, plans) {
      state.plansDashboard = plans
    },
    SET_MAIN_CATEGORIES_FILTER_DASHBOARD (state, mainCategories) {
      state.mainCategoriesDashboard = mainCategories
    },
    // Filtros do gráfico Distribuição de conciliação
    SET_PERIOD_FILTER_CONCILIATION_SITUATION_SUMMARY (state, period) {
      state.periodFilterConcSitSummary = {...period}
    },
    SET_PLAN_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY (state, planSelected) {
      state.planSelectedFilterConcSitSummary = planSelected
    },
    SET_TYPE_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY (state, typeSelected) {
      state.typeFilterConcSituationSummary = typeSelected
    },
    SET_MAIN_CATEGORY_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY (state, mainCategorySelected) {
      state.mainCategorySelectedFilterConcSitSummary = mainCategorySelected
    },
    // Filtros do gráfico Lançamentos conciliados
    SET_PERIOD_FILTER_BATCH_DISTRIBUTION (state, period) {
      state.periodFilterAllotmentDistribution = {...period}
    },
    SET_PLAN_SELECTED_FILTER_BATCH (state, planSelected) {
      state.planSelectedFilterBatch = planSelected
    },
    SET_TYPE_SELECTED_FILTER_BATCH (state, typeSelected) {
      state.typeSelectedFilterBatch = typeSelected
    },
    SET_MAIN_CATEGORY_SELECTED_FILTER_BATCH (state, mainCategorySelected) {
      state.mainCategorySelectedFilterBatch = mainCategorySelected
    },
    // Filtros do gráfico Resumo financeiro
    SET_PERIOD_FILTER_FINANCIAL_SUMMARY (state, period) {
      state.periodFilterFinancialSummary = {...period}
    },
    SET_MAIN_CATEGORY_SELECTED_FILTER_FINANCIAL_SUMMARY (state, mainCategorySelected) {
      state.mainCategorySelectedFilterFinancialSummary = mainCategorySelected
    },
    // Filtros do gráfico Saldo bancário
    SET_PERIOD_SELECTED_FILTER_BANK_BALANCE (state, periodo) {
      state.periodFilterBankBalance = {...periodo}
    },
    SET_ACCOUNT_SELECTED_FILTER_BANK_BALANCE (state, accSelected) {
      state.accountSelectedBankBalance = accSelected
    },
    // Filtros do gráfico Saldo carteira digital
    SET_PERIOD_SELECTED_FILTER_DIGITAL_WALLET_BALANCE (state, periodo) {
      state.periodFilterDigitalWalletBalance = {...periodo}
    },
    SET_CATEGORY_SELECTED_FILTER_DIGITAL_WALLET_BALANCE (state, categorySelected) {
      state.categorySelectedDigitalWalletBalance = categorySelected
    }
  },

  actions: {
    /* --- GADGETS --- */

    // Faz a requisição para trazer os gadgets disponíveis
    getGadgets: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashBoard/gadgets').then(response => {
          let avaliableGadgets = response.data.data
          let avaliableFunctionlitiesGadgets = []
          if (avaliableGadgets && avaliableGadgets.length > 0) {
            avaliableGadgets.forEach(avaliableGadget => {
              if (store.getters.allowedFuncionalities.indexOf(avaliableGadget.funcionalidade.idFuncionalidade) >= 0) {
                avaliableFunctionlitiesGadgets.push(avaliableGadget)
              }
            })
          }
          commit('SET_AVAILABLE_GADGETS', avaliableFunctionlitiesGadgets)
          resolve(response)
        }).catch((error) => {
          commit('SET_AVAILABLE_GADGETS', [])
          reject(error)
        })
      })
    },

    // Salva a configuração dos gráficos e filtros
    setGadgetConfig: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashboard/salvaConfiguracao', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    updateGadgetList: ({ commit }, gadgets) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashboard/atualizaListaGadgets', gadgets).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    cleanGadgetsFilters: ({ commit }) => {
      commit('CLEAN_GADGETS_FILTERS')
    },

    /* --- FILTROS GLOBAIS --- */

    setDashboardDateFilter: ({ commit }, period) => {
      return new Promise((resolve, reject) => {
        commit('SET_PERIOD_DASHBOARD', period)
        commit('SET_PERIOD_SELECTED_FILTER_BANK_BALANCE', period)
        commit('SET_PERIOD_FILTER_BATCH_DISTRIBUTION', period)
        commit('SET_PERIOD_FILTER_FINANCIAL_SUMMARY', period)
        commit('SET_PERIOD_FILTER_CONCILIATION_SITUATION_SUMMARY', period)
        commit('SET_PERIOD_SELECTED_FILTER_DIGITAL_WALLET_BALANCE', period)
        resolve()
      })
    },

    setPlansDashboard: ({ commit }, plans) => {
      return new Promise((resolve, reject) => {
        commit('SET_PLANS_FILTER_DASHBOARD', plans)
        resolve()
      })
    },

    setMainCategoriesDashboard: ({ commit }, mainCategories) => {
      return new Promise((resolve, reject) => {
        commit('SET_MAIN_CATEGORIES_FILTER_DASHBOARD', mainCategories)
        resolve()
      })
    },

    /* --- REQUISICAO PARA O BACK-END --- */

    // Faz a requisição para carregar os dados do gráfico "Distribuição de conciliação"
    getDataConciliationSituationSummary: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashboard/resumoSituacaoConciliacao', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    // Faz a requisição para carregar os dados do grafico "Lançamentos conciliados"
    getDataAllotmentDistributionSummary: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashboard/distribuicaoDeConciliacao', filter)
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    // Faz a requisição para carregar os dados do gráfico "Resumo financeiro"
    getDataFinancialSummary: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashboard/resumoFinanceiro', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    // Faz a requisição para carregar os dados do grafico "Saldo bancário"
    getDataDailyBankStatment: ({ state, commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashboard/saldoBancario', filter)
        .then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    // Faz a requisição para carregar os dados do gráfico "Tarefas"
    getDataTasks: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashboard/tarefas').then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    // Faz a requisição para carregar os dados do grafico "Saldo carteira digital"
    getDataDigitalWalletBalance: ({ state, commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/dashboard/saldoCarteiraDigital', filter)
        .then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    /* --- SET DE FILTROS DO GRAFICO DISTRIBUICAO DA CONCILIACAO --- */

    setPlanSelectedFilterConcSitSummary: ({ commit }, planSelected) => {
      return new Promise((resolve, reject) => {
        commit('SET_PLAN_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY', planSelected)
        resolve()
      })
    },

    setTypeFilterConcSitSummary: ({ commit }, type) => {
      return new Promise((resolve, reject) => {
        commit('SET_TYPE_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY', type)
        resolve()
      })
    },

    setMainCategorySelectedFilterConcSitSummary: ({ commit }, mainCategorySelected) => {
      return new Promise((resolve, reject) => {
        commit('SET_MAIN_CATEGORY_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY', mainCategorySelected)
        resolve()
      })
    },

    /* --- SET DE FILTROS DO GRAFICO LANCAMENTO CONCILIADOS --- */

    setPlanSelectedAllotmentDistributionSummary: ({ commit }, planSelected) => {
      return new Promise((resolve, reject) => {
        commit('SET_PLAN_SELECTED_FILTER_BATCH', planSelected)
        resolve()
      })
    },

    setTypeFilterBatchDistribution: ({ commit }, type) => {
      return new Promise((resolve, reject) => {
        commit('SET_TYPE_SELECTED_FILTER_BATCH', type)
        resolve()
      })
    },

    setMainCategorySelectedAllotmentDistributionSummary: ({ commit }, mainCategorySelected) => {
      return new Promise((resolve, reject) => {
        commit('SET_MAIN_CATEGORY_SELECTED_FILTER_BATCH', mainCategorySelected)
        resolve()
      })
    },

    /* --- SET DE FILTROS DO GRAFICO RESUMO FINANCEIRO --- */

    setMainCategorySelectedFinancialSummary: ({ commit }, mainCategorySelected) => {
      return new Promise((resolve, reject) => {
        commit('SET_MAIN_CATEGORY_SELECTED_FILTER_FINANCIAL_SUMMARY', mainCategorySelected)
        resolve()
      })
    },

    /* --- SET DE FILTROS DO GRAFICO SALDO BANCARIO --- */

    setAccountSelectedBankBalance: ({ commit }, accSelected) => {
      return new Promise((resolve, reject) => {
        commit('SET_ACCOUNT_SELECTED_FILTER_BANK_BALANCE', accSelected)
        resolve()
      })
    },

    /* --- SET DE FILTROS DO GRAFICO SALDO CARTEIRA DIGITAL --- */

    setCategorySelectedDigitalWalletBalance: ({ commit }, categorySelected) => {
      return new Promise((resolve, reject) => {
        commit('SET_CATEGORY_SELECTED_FILTER_DIGITAL_WALLET_BALANCE', categorySelected)
        resolve()
      })
    },

    /* --- CANCEL REQUEST --- */

    cancelDashboardRequests: ({ state }) => {
      for (const key in state.currentRequests) {
        if (state.currentRequests[key]) {
          if (typeof state.currentRequests[key].cancel === 'function') {
            state.currentRequests[key].cancel()
          }
          delete state.currentRequests[key]
        }
      }
    }
  },

  getters: {
    // Globais
    availableGadgets: state => state.availableGadgets,
    periodDashboard: state => state.periodDashboard,
    plansDashboard: state => state.plansDashboard,
    mainCategoriesDashboard: state => state.mainCategoriesDashboard,
    // Filtros do gráfico Distribuição de conciliação
    periodFilterConcSitSummary: state => state.periodFilterConcSitSummary,
    planSelectedFilterConcSitSummary: state => state.planSelectedFilterConcSitSummary,
    typeFilterConcSituationSummary: state => state.typeFilterConcSituationSummary,
    mainCategorySelectedFilterConcSitSummary: state => state.mainCategorySelectedFilterConcSitSummary,
    // Filtros do gráfico Lançamentos conciliados
    periodFilterAllotmentDistribution: state => state.periodFilterAllotmentDistribution,
    planSelectedFilterBatch: state => state.planSelectedFilterBatch,
    typeSelectedFilterBatch: state => state.typeSelectedFilterBatch,
    mainCategorySelectedFilterBatch: state => state.mainCategorySelectedFilterBatch,
    // Filtros do gráfico Resumo financeiro
    periodFilterFinancialSummary: state => state.periodFilterFinancialSummary,
    mainCategorySelectedFilterFinancialSummary: state => state.mainCategorySelectedFilterFinancialSummary,
    // Filtros do gráfico Saldo bancário
    periodFilterBankBalance: state => state.periodFilterBankBalance,
    accountSelectedBankBalance: state => state.accountSelectedBankBalance,
    // Filtros do gráfico Saldo carteira digital
    periodFilterDigitalWalletBalance: state => state.periodFilterDigitalWalletBalance,
    categorySelectedDigitalWalletBalance: state => state.categorySelectedDigitalWalletBalance
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/dashboard.js